import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants.js'

const SELECTORS = {
  socialShare: '.js-social-share',
  copyButton: '.js-social-share-copy',
  expandButton: '.js-social-share-expand',
  linkCopiedButton: '.js-social-share-link-copied',
  buttonGroup: '.js-social-share-btn-group',
  newWindowLink: '.js-social-share__new-window',
  status: '.js-social-status'
}

class SocialShare {
  constructor (element) {
    this.element = element
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.copyButton = this.element.querySelector(SELECTORS.copyButton)
    this.contentText = this.copyButton.dataset.text
    this.expandButton = this.element.querySelector(SELECTORS.expandButton)
    this.buttonGroup = this.element.querySelector(SELECTORS.buttonGroup)
    this.linkCopiedButton = this.element.querySelector(SELECTORS.linkCopiedButton)
    this.newWindowLink = this.element.querySelectorAll(SELECTORS.newWindowLink)
    this.status = this.element.querySelector(SELECTORS.status)
    this.tabbableLinks = this.element.querySelectorAll('.social-share__link')

    this.init()
  }

  init() {
    this.registerEventHandlers()

    Array.from(this.element.children).forEach((item, index) => {
      this.element.style.setProperty(`--item-${index}`, `${item.offsetWidth}px`)
    })

    this.element.dataset.state = 'closed'
  }

  registerEventHandlers() {
    if (navigator.clipboard) {
      this.copyButton.addEventListener(GLOBAL_CONSTANTS.EVENTS.CLICK, this.copyText)
    } else {
      this.copyButton.remove()
      console.info('navigator.clipboard is only available over https')
    }

    this.newWindowLink.forEach(link => {
      link.addEventListener(GLOBAL_CONSTANTS.EVENTS.CLICK, (e) => this.openWindow(e, link))
    })

    if (this.expandButton) {
      this.expandButton.addEventListener(GLOBAL_CONSTANTS.EVENTS.CLICK, this.handleClick)
      this.expandButton.addEventListener('touchend', (evt) => {
        evt.preventDefault()
        this.handleClick()
      })
      this.expandButton.addEventListener(GLOBAL_CONSTANTS.EVENTS.MOUSEENTER, this.expandContent)
      this.element.addEventListener(GLOBAL_CONSTANTS.EVENTS.MOUSELEAVE, this.collapseContent)

      this.element.addEventListener('focusout', (evt) => {
        if (this.element.contains(evt.relatedTarget)) return

        this.mouseEnterFlag = false
        this.transitionFlag = false
        this.closeAfterCopy()
      })
    }

    this.element.addEventListener('transitionstart', () => {
      this.transitionFlag = true
    })

    this.element.addEventListener('transitionend', () => {
      this.transitionFlag = false
    })

    this.element.addEventListener(GLOBAL_CONSTANTS.EVENTS.MOUSEENTER, () => {
      this.mouseEnterFlag = true
    })

    this.element.addEventListener(GLOBAL_CONSTANTS.EVENTS.MOUSELEAVE, () => {
      this.mouseEnterFlag = false
    })
  }

  copyText = () => {
    navigator.clipboard.writeText(this.contentText)
    this.showLinkCopiedButton()
  }

  handleClick = () => {
    if (this.transitionFlag) return

    if (this.element.dataset.state !== 'opened') {
      this.expandContent()
    } else {
      this.collapseContent()
    }
  }

  toggleTabIndex = () => {
    if (this.element.dataset.state !== 'opened') {
      this.tabbableLinks.forEach((link) => {
        link.setAttribute('tabindex', '-1')
      })
    } else {
      this.tabbableLinks.forEach((link) => {
        link.removeAttribute('tabindex')
      })
    }
  }

  expandContent = () => {
    if (this.transitionFlag) return

    if (this.expandButton) {
      this.expandButton.ariaExpanded = true
      this.expandButton.setAttribute('tabindex', '-1')
    }

    this.buttonGroup.ariaHidden = false
    this.element.dataset.state = 'opened'
    this.toggleTabIndex()
  }

  collapseContent = () => {
    if (this.expandButton) {
      this.expandButton.ariaExpanded = false
      this.expandButton.removeAttribute('tabindex')
    }

    this.buttonGroup.ariaHidden = true
    this.element.dataset.state = 'closed'
    this.toggleTabIndex()
  }

  showLinkCopiedButton = () => {
    if (this.expandButton) {
      this.expandButton.ariaExpanded = false
    }

    this.linkCopiedButton.ariaHidden = false
    this.buttonGroup.ariaHidden = true
    this.element.dataset.state = 'shared'
    this.status.innerHTML = 'Link copied'
    this.toggleTabIndex()

    setTimeout(() => {
      if (this.mouseEnterFlag) {
        this.element.addEventListener(GLOBAL_CONSTANTS.EVENTS.MOUSELEAVE, this.closeAfterCopy)
      } else {
        this.closeAfterCopy()
      }
    }, 2000)
  }

  closeAfterCopy = () => {
    if (this.transitionFlag) return

    this.linkCopiedButton.ariaHidden = true
    this.status.innerHTML = ''
    this.collapseContent()

    this.element.removeEventListener(GLOBAL_CONSTANTS.EVENTS.MOUSELEAVE, this.closeAfterCopy)
  }

  openWindow = (e, link) => {
    e.preventDefault()
    window.open(link.href, 'targetWindow',
      `toolbar=no,
       location=no,
       status=no,
       menubar=no,
       scrollbars=yes,
       resizable=yes,
       width=550,
       height=450`)
  }
}

export default {
  selector: SELECTORS.socialShare,
  Source: SocialShare
}
